<script>
  import EntitlementsReport from './EntitlementsReport.svelte';
  import LicensesReport from './LicensesReport.svelte';
  import LazyLoadedTabContent from '../../components/LazyLoadedTabContent.svelte';
  import TabsWithRouting from '../../components/TabsWithRouting.svelte';
</script>

<div class="system-tabs">
  <TabsWithRouting
    defaultHash="#entitlements"
    tabsWrapperProps={{ 'aria-label': 'Reports tabs' }}
    tabs={[
      { label: 'Entitlements Report', hash: '#entitlements' },
      { label: 'Licenses Report', hash: '#licenses' },
    ]}
  >
    <LazyLoadedTabContent hash="#entitlements"><EntitlementsReport /></LazyLoadedTabContent>
    <LazyLoadedTabContent hash="#licenses"><LicensesReport /></LazyLoadedTabContent>
  </TabsWithRouting>
</div>

<style>
  @media (min-width: 42rem) {
    .system-tabs :global(.bx--tabs__nav-link) {
      width: 11rem;
    }
  }
</style>
